<template>

  <section id="formulario" class="bg-[#57af4e] p-6 plex-regular" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto w-full md:max-w-7xl lg:max-w-5xl bg-white bg-opacity-85 rounded-lg p-6">

        <div class="w-full py-6">
          <h1 class="plex-semibold text-xl text-gray-800">CREDENCIAL</h1>
          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario para descargar su credencial</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2">
            <label class="block mb-1">Documento</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="text" placeholder="Documento"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3 w-full">
          <button type="submit" class="mt-4 w-full md:w-auto px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-arrow-circle-down mr-2"></i>DESCARGAR
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    InputText, BlockUI,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        documento: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required("Ingrese el documento").min(6, "Al menos 6 caracteres"),
      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html:  "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {

        let acreditado:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
        if(!acreditado) {
          this.isSubmitting = false;
          Swal.fire({ title: "¡Atención!",  html: "El acreditado no existe", icon: "error" });
          return;
        }

        if(acreditado.estadoAcreditado.id != VERIFICADO) {
          this.isSubmitting = false;
          Swal.fire({ title: "¡Atención!",  html: "El acreditado todavía no fue verificado", icon: "error" });
          return;
        }
			
        location.href = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash;
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>
